module.exports = __webpack_public_path__ + "static/media/face0ok.64b83817.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face0ok.svg
// module id = 1215
// module chunks = 2